"use client";

import React, { useRef, useState } from "react";
import ParallaxElement from "@/components/common/ParallaxElement";
import styles from "./OtherWorks.module.scss";
import { capitalFlow, luxeMoissanite, tractify, uwa, wiseStore } from "@/utils/routes";
import Link from "next/link";

interface WorkItem {
	name: string;
	type: string;
	link: string;
	industry: string;
	year: number;
}

const worksData: WorkItem[] = [
	{
		name: "Uwa Original",
		type: "Website Design",
		link: uwa,
		industry: "Entertainment",
		year: 2025,
	},
	{
		name: "Tractify",
		type: "Website Design",
		link: tractify,
		industry: "Startup",
		year: 2024,
	},
	{
		name: "Luxe Moissanite",
		type: "Website Design",
		link: luxeMoissanite,
		industry: "E-commerce",
		year: 2024,
	},
	{
		name: "Wise Store",
		type: "Website Design",
		link: wiseStore,
		industry: "E-commerce",
		year: 2023,
	},
	{
		name: "Capital Flow",
		type: "Website Design",
		link: capitalFlow,
		industry: "Startup",
		year: 2025,
	},
];

interface TrailDot {
	id: number;
	x: number;
	y: number;
}

const OtherWorks: React.FC = () => {
	const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
	const [trailDots, setTrailDots] = useState<TrailDot[]>([]);
	const dotIdRef = useRef(0);
	const containerRef = useRef<HTMLDivElement>(null);

	const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>, index: number) => {
		if (hoveredIndex !== index) return;

		const rect = containerRef.current?.getBoundingClientRect();
		if (!rect) return;

		const x = e.clientX - rect.left;
		const y = e.clientY - rect.top;

		const newDot: TrailDot = {
			id: dotIdRef.current++,
			x,
			y,
		};

		setTrailDots((prev) => [...prev, newDot]);

		// Remove dot after animation completes
		setTimeout(() => {
			setTrailDots((prev) => prev.filter((dot) => dot.id !== newDot.id));
		}, 1000);
	};

	return (
		<section className={styles.otherWorks}>
			<div
				className={styles.container}
				ref={containerRef}
				onMouseMove={(e) => {
					if (hoveredIndex !== null) {
						handleMouseMove(e, hoveredIndex);
					}
				}}
			>
				{/* Trail dots */}
				{/* {trailDots.map((dot) => (
					<div
						key={dot.id}
						className={styles.trailDot}
						style={{
							left: `${dot.x}px`,
							top: `${dot.y}px`,
						}}
					/>
				))} */}

				{/* Header */}
				<div className={styles.header}>
					<div className={styles.headerItem}>Others</div>
					<div className={styles.headerItem}>Type</div>
					<div className={styles.headerItem}>Industry</div>
					<div className={styles.headerItem}>Year</div>
				</div>

				{/* Portfolio Items */}
				<div className={styles.itemsContainer}>
					{worksData.map((item, index) => {
						// Alternate parallax speeds for depth: 0.6, 0.8, 0.7, 0.6, 0.8
						const speeds = [0.6, 0.8, 0.7, 0.6, 0.8];
						const speed = speeds[index % speeds.length];

						return (
							// <ParallaxElement key={index} speed={speed} direction="down" distance={40} as="div">
							<Link key={item.name} href={item.link} target="_blank" className={`${styles.workItem} ${hoveredIndex === index ? styles.hovered : ""}`} onMouseEnter={() => setHoveredIndex(index)} onMouseLeave={() => setHoveredIndex(null)}>
								<div className={styles.itemName}>
									<span className={styles.nameText}>{item.name}</span>
									<div className={styles.underline} />
								</div>
								<div className={styles.itemType}>{item.type}</div>
								<div className={styles.itemIndustry}>{item.industry}</div>
								<div className={styles.itemYear}>{item.year}</div>
								<div className={styles.mobileContent}>
									<div className={styles.mobileInfo}>
										{item.type} &bull; {item.industry}
									</div>
									<div className={styles.liveSiteButton}>
										<svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
											<rect width="18.2315" height="17" rx="8" fill="#FF0000" fillOpacity="0.26" style={{ fill: "#FF0000", fillOpacity: 0.26 }} />
											<path d="M9.59304 13.1383L8.69815 12.2534L11.8054 9.14613H4V7.85352H11.8054L8.69815 4.75124L9.59304 3.86133L14.2315 8.49982L9.59304 13.1383Z" fill="#1E1E1E" style={{ fill: "#1E1E1E", fillOpacity: 1 }} />
										</svg>
										Live Site
									</div>
								</div>
							</Link>
							// </ParallaxElement>
						);
					})}
				</div>
			</div>
		</section>
	);
};

export default OtherWorks;
